/**
 * Experiment cookies for feature flags in the quote tool.
 * These cookies control the availability of experimental features.
 */

export const ONLINE_COURSES_WAYFINDER_BANNER_COOKIE = 'lx.features.online-courses-wayfinder-banner';
